import Vue from "vue";
import Router from "vue-router";

import { notifier } from '@/shared/lib/notifier/index';
import { AclHandler } from "@/services/acl-handler";

import i18n from './i18n';
import store from "./store";
import { menuDescription } from './menu';

// import Home from "./views/home";

// import Purchase from "./views/purchase/purchase";
// import Purchases from "./views/purchase/purchases";
import Consumables from './views/consumables/consumables.vue';
import User from "./views/user/user";
import Users from "./views/user/users";
import Log from "./views/log/log";
import Logs from "./views/log/logs";
import Reports from "./views/reports/reports.vue"
import Report from "./views/reports/report.vue"
import Notifications from "./views/notification/notifications";
import Notification from "./views/notification/notification";
import Settings from "./views/settings/settings.vue";
// import Service from "./views/service/service.vue";
import License from "./views/license/license.vue";
import Licenses from "./views/license/licenses.vue";
import Product from "./views/product/product.vue";
import Locations from "./views/locations/locations.vue";
// import Material from "./views/material/material";
// import Materials from "./views/material/materials";
// import AssemblyExport from "./views/assembly-export/detail";
// import AssemblyExports from "./views/assembly-export/list";
// import Assembly from "./views/assembly-export/assembly/index";
// import AssemblyReport from "./views/assembly-export/report/tabview";
// import Transactions from "./views/transaction/transactions";
// import Transaction from "./views/transaction/transaction";
// import Requirement from "./views/requirements/requirement/index";
// import Requirements from "./views/requirements/requirements";
// import Sale from "./views/sales/detail";
// import Sales from "./views/sales/sales";

import defaultLayout from "./layouts/side-nav-outer-toolbar";
import simpleLayout from "./layouts/single-card";

Vue.use(Router);

const getRoutePermissions = (route) => route.matched
  .filter(record => record.meta && record.meta.itemPermission)
  .map(record => record.meta.itemPermission);

const cloudModeDisabledRoutes = ['queues', 'logs', 'settings'];
const agentLogsRouteContext = 'agent-logs';

const isCloudModeDisabledRoute = (route) => route.matched.some(
  record => record.meta && cloudModeDisabledRoutes.includes(record.meta.menu)
);

const isAgentLogsTabRoute = (route) => route.name === 'agent'
  && route.query
  && route.query.tab === agentLogsRouteContext;

const isAgentLogDetailRoute = (route) => route.name === 'log'
  && route.query
  && route.query.context === agentLogsRouteContext;

const isAgentLogDetailNavigation = (to, from) => isAgentLogDetailRoute(to)
  && (isAgentLogsTabRoute(from) || isAgentLogDetailRoute(from));

const router = new Router({
  routes: [
    {
      path: "/home",
      name: "home",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () => import(/* webpackChunkName: "home" */ "./views/home/home")
      }
    },
    {
      path: "/agent/:id?",
      name: "agent",
      meta: {
        requiresAuth: true,
        menu: "agents",
        itemPermission : {
          componentCode : 'MNU_AGENTS',
          operationCode : 'READ'
        }
      },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: () => import(/* webpackChunkName: "agents" */ "./views/agent/agent")
      }
    },
    {
      path: "/agents",
      alias: [
        '/agents?',
      ],
      name: "agents",
      meta: {
        requiresAuth: true,
        menu: "agents",
        itemPermission : {
          componentCode : 'MNU_AGENTS',
          operationCode : 'READ'
        }
      },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: () => import(/* webpackChunkName: "agents" */ "./views/agent/agents")
      }
    },
    {
      path: "/network/:id?",
      name: "network",
      meta: {
        requiresAuth: true,
        menu: "networks",
        itemPermission : {
          componentCode : 'MNU_NETWORK_RANGES',
          operationCode : 'READ'
        }
      },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: () => import(/* webpackChunkName: "networks" */ "./views/network/network")
      }
    },
    {
      path: "/networks",
      alias: [
        '/networks?',
      ],
      name: "networks",
      meta: {
        requiresAuth: true,
        menu: "networks",
        itemPermission : {
          componentCode : 'MNU_NETWORK_RANGES',
          operationCode : 'READ'
        }
      },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: () => import(/* webpackChunkName: "networks" */ "./views/network/networks")
      }
    },
    {
      path: "/dictionary/:id",
      name: "dictionary",
      meta: {
        requiresAuth: true,
        menu: "dictionaries",
        itemPermission : {
          componentCode : 'MNU_DICTIONARIES',
          operationCode : 'READ'
        }
      },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: () => import(/* webpackChunkName: "dictionaries" */ "./views/dictionary/dictionary")
      }
    },
    {
      path: "/dictionaries",
      name: "dictionaries",
      meta: {
        requiresAuth: true,
        menu: "dictionaries",
        itemPermission : {
          componentCode : 'MNU_DICTIONARIES',
          operationCode : 'READ'
        }
      },
      components: {
        layout: defaultLayout,
        content: () => import(/* webpackChunkName: "dictionaries" */ "./views/dictionary/dictionaries")
      }
    },
    {
      path: "/locations",
      name: "locations",
      meta: {
        requiresAuth: true,
        menu: "locations"
      },
      components: {
        layout: defaultLayout,
        content: Locations
      }
    },
    {
      path: "/location/:id?",
      name: "location",
      meta: {
        requiresAuth: true,
        menu: "locations"
      },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: () => import(/* webpackChunkName: "dictionaries" */ "./views/locations/location.vue")
      }
    },
    {
      path: "/devices",
      alias: [
        '/devices?',
      ],
      name: "devices",
      meta: {
        requiresAuth: true,
        menu: "devices",
        itemPermission : {
          componentCode : 'MNU_DEVICES',
          operationCode : 'READ'
        }
      },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: () => import(/* webpackChunkName: "devices" */ "./views/device/devices")
      }
    },
    {
      path: "/device/:id?",
      name: "device",
      meta: {
        requiresAuth: true,
        menu: "devices",
        itemPermission : {
          componentCode : 'MNU_DEVICES',
          operationCode : 'READ'
        }
      },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: () => import(/* webpackChunkName: "devices" */ "./views/device/device")
      }
    },
    {
      path: "/consumables",
      name: "consumables",
      meta: {
        requiresAuth: true,
        menu: "consumables",
        itemPermission : {
          componentCode : 'MNU_DEVICES',
          operationCode : 'READ'
        }
      },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: Consumables
      }
    },
    // {
    //   path: "/queues",
    //   name: "queues",
    //   meta: {
    //     requiresAuth: true,
    //     menu: "queues",
    //     itemPermission : {
    //       componentCode : 'MNU_QUEUES',
    //       operationCode : 'READ'
    //     }
    //   },
    //   components: {
    //     layout: defaultLayout,
    //     content: () => import(/* webpackChunkName: "queues" */ "./views/queues/queues")
    //   }
    // },
    // {
    //   path: "/queue/:id?",
    //   name: "queue",
    //   meta: {
    //     requiresAuth: true,
    //     menu: "queues",
    //     itemPermission : {
    //       componentCode : 'MNU_QUEUES',
    //       operationCode : 'READ'
    //     }
    //   },
    //   props: { content: true },
    //   components: {
    //     layout: defaultLayout,
    //     content: () => import(/* webpackChunkName: "queues" */ "./views/queues/queue")
    //   }
    // },
    {
      path: "/reports",
      name: "reports",
      meta: {
        requiresAuth: true,
        menu: "reports",
        itemPermission : {
          componentCode : 'MNU_REPORTS',
          operationCode : 'READ'
        }
      },
      components: {
        layout: defaultLayout,
        content: Reports
      }
    },
    {
      path: "/report/:code?",
      name: "report",
      meta: {
        requiresAuth: true,
        menu: "reports",
        itemPermission : {
          componentCode : 'MNU_REPORTS',
          operationCode : 'READ'
        }
      },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: Report
      }
    },
    {
      path: "/user/:id?",
      name: "user",
      meta: {
        requiresAuth: true,
        menu: "users",
        itemPermission : {
          componentCode : 'MNU_USERS',
          operationCode : 'READ'
        }
      },
      props: true,
      components: {
        layout: defaultLayout,
        content: User
      }
    },
    {
      path: "/users",
      name: "users",
      meta: {
        requiresAuth: true,
        menu: "users",
        itemPermission : {
          componentCode : 'MNU_USERS',
          operationCode : 'READ'
        }
      },
      components: {
        layout: defaultLayout,
        content: Users
      }
    },
    {
      path: "/log/:id?",
      name: "log",
      meta: {
        requiresAuth: true,
        menu: "logs",
        itemPermission : {
          componentCode : 'MNU_LOG_EVENTS',
          operationCode : 'READ'
        }
      },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: Log
      }
    },
    {
      path: "/logs",
      name: "logs",
      meta: {
        requiresAuth: true,
        menu: "logs",
        itemPermission : {
          componentCode : 'MNU_LOG_EVENTS',
          operationCode : 'READ'
        }
      },
      components: {
        layout: defaultLayout,
        content: Logs
      }
    },

    {
      path: "/notifications",
      name: "notifications",
      meta: {
        requiresAuth: true,
        menu: "notifications",
        itemPermission : {
          componentCode : 'MNU_NOTIFICATIONS',
          operationCode : 'READ'
        }
      },
      components: {
        layout: defaultLayout,
        content: Notifications
      }
    },
    {
      path: "/notification/:id?",
      name: "notification",
      meta: {
        requiresAuth: true,
        menu: "notifications",
        itemPermission : {
          componentCode : 'MNU_NOTIFICATIONS',
          operationCode : 'READ'
        }
      },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: Notification
      }
    },
    {
      path: "/settings",
      name: "settings",
      meta: {
        requiresAuth: true,
        menu: "settings",
        itemPermission : {
          componentCode : 'MNU_SETTINGS',
          operationCode : 'READ'
        }
      },
      components: {
        layout: defaultLayout,
        content: Settings
      }
    },
    // {
    //   path: "/service",
    //   name: "service",
    //   meta: {
    //     requiresAuth: true,
    //     menu: "service",
    //     itemPermission : {
    //       componentCode : 'MNU_SERVICE',
    //       operationCode : 'READ'
    //     }
    //   },
    //   components: {
    //     layout: defaultLayout,
    //     content: Service
    //   }
    // },
    {
      path: "/licenses",
      name: "licenses",
      meta: {
        requiresAuth: true,
        menu: "licenses",
        itemPermission : {
          roleCodes: ['ADMIN', 'DEVELOPER'],
          componentCode : 'MNU_LICENSE',
          operationCode : 'READ'
        }
      },
      components: {
        layout: defaultLayout,
        content: Licenses
      }
    },
    {
      path: "/license/:id?",
      name: "license",
      meta: {
        requiresAuth: true,
        menu: "licenses",
        itemPermission : {
          roleCodes: ['ADMIN', 'DEVELOPER'],
          componentCode : 'MNU_LICENSE',
          operationCode : 'READ'
        }
      },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: License
      }
    },
    {
      path: "/product",
      name: "product",
      meta: {
        requiresAuth: true,
        menu: "product"
      },
      components: {
        layout: defaultLayout,
        content: Product
      }
    },

    /*
    {
      path: "/purchases",
      name: "purchases",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: Purchases
      }
    },
    {
      path: "/purchase/:id",
      name: "purchase",
      meta: { requiresAuth: true },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: Purchase
      }
    },
    {
      path: "/materials",
      name: "materials",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: Materials
      }
    },
    {
      path: "/material/:id",
      name: "material",
      meta: { requiresAuth: true },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: Material
      }
    },
    {
      path: "/assembly-exports",
      name: "assembly-exports",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: AssemblyExports
      }
    },
    {
      path: "/assembly-export/:id",
      name: "assembly-export",
      meta: { requiresAuth: true },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: AssemblyExport
      }
    },
    {
      path: "/assembly/:id",
      name: "assembly",
      meta: { requiresAuth: true },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: Assembly
      }
    },
    {
      path: "/assembly-export/:exportId/report/:reportId",
      name: "assembly-report",
      meta: { requiresAuth: true },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: AssemblyReport
      }
    },
    {
      path: "/transaction/:id",
      name: "transaction",
      meta: { requiresAuth: true },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: Transaction
      }
    },
    {
      path: "/transactions",
      name: "transactions",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: Transactions
      }
    },
    {
      path: "/requirement/:id",
      name: "requirement",
      meta: { requiresAuth: true },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: Requirement
      }
    },
    {
      path: "/requirements",
      name: "requirements",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: Requirements
      }
    },
    {
      path: "/sales",
      name: "sales",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: Sales
      }
    },
    {
      path: "/sale/:id",
      name: "sale",
      meta: { requiresAuth: true },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: Sale
      }
    },
    {
      path: "/outsource-in",
      name: "outsource-in-list",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () => import(/ * webpackChunkName: "outsource" * / "./views/outsource/in-list")
      }
    },
    {
      path: "/outsource-in/:id",
      name: "outsource-in",
      meta: { requiresAuth: true },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: () => import(/ * webpackChunkName: "outsource" * / "./views/outsource/in-detail/tabview")
      }
    },
    {
      path: "/outsource-out",
      name: "outsource-out-list",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () => import(/ * webpackChunkName: "outsource" * / "./views/outsource/out-list")
      }
    },
    {
      path: "/outsource-out/:id",
      name: "outsource-out",
      meta: { requiresAuth: true },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: () => import(/ * webpackChunkName: "outsource" * / "./views/outsource/out-detail")
      }
    },
    {
      path: "/complectations",
      name: "complectations",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () => import(/ * webpackChunkName: "complectation" * / "./views/complectation/complectations")
      }
    },
    {
      path: "/complectation/:id",
      name: "complectation",
      meta: { requiresAuth: true },
      props: { content: true },
      components: {
        layout: defaultLayout,
        content: () => import(/ * webpackChunkName: "complectation" * / "./views/complectation/complectation")
      }
    },
*/

    {
      path: "/login-form",
      name: "login-form",
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayout,
        // route level code-splitting
        // this generates a separate chunk (login.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        content: () =>
          import(/* webpackChunkName: "login" */ "./views/login-form")
      }
    },
    {
      path: "/restore-password/:token?",
      name: "restore-password",
      meta: { requiresAuth: false },
      props: { content: true },
      components: {
        layout: simpleLayout,
        content: () =>
          import("./views/restore-password-form")
      }
    },
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/recovery",
      redirect: "/home"
    },
    {
      path: "*",
      redirect: "/home"
    }

  ]
});

router.beforeEach((to, from, next) => {
  if (to.name === "login-form" && store.getters.token && store.getters.token.login) {
    next({ name: "home" });
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.token || !store.getters.user || !store.getters.user.login) {
      next({
        name: "login-form",
        query: { redirect: to.fullPath }
      });
    } else {
      const isCloudMode = store.getters.isCloudMode;
      const aclHandler = new AclHandler(store.getters.user, isCloudMode);
      const canOpenAgentLogDetail = isCloudMode && isAgentLogDetailNavigation(to, from);

      if (isCloudMode && !aclHandler.hasDefaultLocation() && !canOpenAgentLogDetail && isCloudModeDisabledRoute(to)) {
        notifier.showError(i18n.t('general.disabledRouteNotification'));
        next({ name: "home" });
        return;
      }

      const matchedPermissions = getRoutePermissions(to);

      if (matchedPermissions.length === 0 || canOpenAgentLogDetail) {
        next();
        return;
      }

      const hasRoutePermission = matchedPermissions.every(permission => aclHandler.hasPermission(permission));

      if (hasRoutePermission) {
        next();
      } else {
        notifier.showError(i18n.t('general.disabledRouteNotification'));
        next({ name: "home" });
      }
    }
  } else {
    next();
  }
});

const lastShown = new Map();
const licenseCheckRoutes = new Set([
  ...menuDescription.map(item => item.name), // проверка по элементам меню
  'home',
]);

router.afterEach((to) => {
  const key = to.name;

  if (lastShown.get(key)) return;

  lastShown.set(key, true);
  setTimeout(() => lastShown.delete(key), 2000);

  const userLicensesRelevant = store.getters.userLicensesRelevant;
  const shouldShowLicenseError = licenseCheckRoutes.has(to.name);

  if (userLicensesRelevant && userLicensesRelevant.status !== 'OK' && shouldShowLicenseError)
    notifier.showError(userLicensesRelevant.statusDescription);
});

export default router;
